__turbopack_context__.v({
  "button": "styles-module__YGyGCW__button",
  "loadMore": "styles-module__YGyGCW__loadMore",
});
